import _objectDestructuringEmpty from '@babel/runtime/helpers/objectDestructuringEmpty';
import _extends from '@babel/runtime/helpers/extends';
import React from 'react';
import Layout from './Layout.js';
import Formwizard from '../../../wizard/index.js';
import WizardHeading from './WizardHeading.js';
import Footer from './Footer.js';
import StartLayoutContainer from './StartLayoutContainer.js';
import UserDataStepLayoutContainer from './UserDataStepLayoutContainer.js';
import RendererLayoutContainer from './RendererLayoutContainer.js';
import NavigationButtonsLayoutContainer from './NavigationButtonsLayoutContainer.js';
import CalculationLayoutContainer from './CalculationLayoutContainer.js';
import { jsx } from '@emotion/react';
var Highlighted = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  return jsx(Layout, {
    ref: ref
  }, jsx(Formwizard, _extends({
    components: {
      WizardHeading: WizardHeading,
      StartLayoutContainer: StartLayoutContainer,
      UserDataStepLayoutContainer: UserDataStepLayoutContainer,
      RendererLayoutContainer: RendererLayoutContainer,
      NavigationButtonsLayoutContainer: NavigationButtonsLayoutContainer,
      CalculationLayoutContainer: CalculationLayoutContainer
    }
  }, props)), jsx(Footer, null));
});
export { Highlighted as default };